import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const TimesheetFormWrapper = styled("div")(() => ({
  backgroundColor: colors.gray50,
  borderRadius: 12,
  padding: 24,
  width: "100%",
}));
